import { DtoApiPager } from "./abst/DtoApiPager";
import { DtoRequestCarusesGetRes } from "./abst/DtoRequestCarusesGetRes";

export class DtoRequestCarusesGetResImple extends DtoRequestCarusesGetRes {
  public pager = new DtoApiPager();
}
